import { useEffect } from 'react';
import './App.css';
import Header from './Components/Header';
import Hero from './Components/Hero';
import Features from './Components/Features';
import Courses from './Components/Courses';
import Gallery from './Components/Gallery';
import KnowledgeHub from './Components/KnowledgeHub';
import HealthyLifeGuide from './Components/HealthyLifeGuide';
import LearningJourney from './Components/LearningJourney';
import About from './Components/About';
import Director from './Components/Director';
import Faq from './Components/Faq';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {
  useEffect(() => {
    let animationFrame;

    const scrollToHash = () => {
      const sectionId = window.location.hash.slice(1);
      if (!sectionId) return;

      const section = document.getElementById(decodeURIComponent(sectionId));
      if (section && typeof section.scrollIntoView === 'function') {
        section.scrollIntoView({ block: 'start' });
      }
    };

    // Wait until the page layout has been painted before handling a direct URL.
    animationFrame = window.requestAnimationFrame(scrollToHash);
    window.addEventListener('hashchange', scrollToHash);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('hashchange', scrollToHash);
    };
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Features />
      <Courses />
      <Gallery />
      <KnowledgeHub />
      <HealthyLifeGuide />
      <LearningJourney />
      <About />
      <Director />
      <Faq />
      <Contact />
      <Footer />

      <a
        href="https://wa.me/919242912480?text=Hi%20I'm%20interested%20in%20your%20courses!"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <span className="whatsapp-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" focusable="false">
            <path d="M16.04 3.2A12.7 12.7 0 0 0 5.13 22.4L3.2 28.8l6.56-1.88a12.74 12.74 0 1 0 6.28-23.72Zm0 2.14a10.57 10.57 0 0 1 0 21.14c-1.86 0-3.68-.49-5.28-1.42l-.38-.22-3.9 1.12 1.14-3.8-.25-.4a10.57 10.57 0 0 1 8.67-16.42Zm-4.7 4.62c-.25 0-.66.1-1 .48-.35.38-1.33 1.3-1.33 3.16s1.36 3.66 1.55 3.91c.18.25 2.67 4.08 6.48 5.72.9.39 1.61.62 2.16.79.91.29 1.73.25 2.38.15.73-.11 2.23-.91 2.55-1.79.31-.87.31-1.62.22-1.78-.09-.16-.34-.25-.72-.44-.37-.19-2.22-1.1-2.56-1.22-.35-.13-.6-.19-.85.19-.25.37-.97 1.22-1.19 1.47-.22.25-.44.28-.81.09-.38-.19-1.58-.58-3.01-1.86a11.22 11.22 0 0 1-2.09-2.59c-.22-.37-.02-.57.17-.76.17-.17.38-.44.57-.66.18-.22.25-.37.37-.62.13-.25.06-.47-.03-.66-.09-.19-.84-2.06-1.16-2.81-.3-.74-.61-.64-.84-.65h-.72Z" />
          </svg>
        </span>
        <strong>Chat with us</strong>
      </a>
    </>
  );
}

export default App;
